const defaultDelay = 5000;

/**
LGWAN環境で無害化処理が詰まってしまう事象が発生したため、これを回避するためのリトライ処理
インシデントチャンネル: https://graffer.slack.com/archives/C07UE95JX0F
*/
export const fetchAttachedFileWithRetry = async (
  fetchFunction: () => Promise<any>,
  maxRetries = 10,
): Promise<any> => {
  for (let attempt = 0; attempt < maxRetries; attempt++) {
    try {
      return await fetchFunction();
    } catch (e) {
      if (e?.response?.status === 429) {
        const delay =
          e?.response?.headers["x-graffer-request-limit-retry-after-ms"] ??
          defaultDelay;
        if (attempt < maxRetries - 1) {
          await new Promise((resolve) => setTimeout(resolve, delay));
        }
      } else {
        // 429 以外のエラーはリトライせず throw する
        throw e;
      }
    }
  }
  throw new Error("Max retries reached");
};
